
export const utilLoopHelper = (data, fn) =>{
    let items = [];
    data.forEach((item, index) => {
        items.push(fn(item, index));
    });
    return items;
}



